/** Returns true when the props are of type [[DayPickerSingle]]. */
export function isDayPickerSingle(props) {
    return props.mode === 'single';
}
//# sourceMappingURL=isDayPickerSingle.js.map